import { Center, Flex, Text, Box } from "@chakra-ui/react";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";

import Button from "../../src/components/common/button";
import Error from "../../src/components/common/error";
import TopBand from "../../src/components/common/topBand";
import { fetchProductCategories } from "../../src/redux/actions";
import { wrapper } from "../../src/redux/store";
import { fetchBlogsForCategory } from "../../src/services/blogService";

import { BLOG_CATEGORY_DETAILS } from "../../src/constants/server";

const BlogList = dynamic(() => import("../../src/components/blog/blogList"));

export default function Blog(props) {
  const router = useRouter();

  if (props.errorMessage) {
    return <Error errorMessage={errorMessage} />;
  }

  const productBlogs = JSON.parse(props.productBlogs);
  const ayurvedaBlogs = JSON.parse(props.ayurvedaBlogs);

  return (
    <>
      <TopBand title="Blogs" />
      <Center mt="10" flexDirection="column">
        {productBlogs && productBlogs.length > 0 && (
          <Box mt="10" mb="5" width={{ base: "90%", "2xl": "1350px" }}>
            <Flex
              flexDirection={{ base: "column", lg: "row" }}
              justifyContent={{ base: "flex-start", lg: "space-between" }}
            >
              <Box>
                <Text
                  lineHeight="1"
                  color="titleColor"
                  variant="headingHomePage"
                >
                  Products information
                </Text>
              </Box>
              <Box>
                <Button
                  mt={{ base: "20px", lg: "0px" }}
                  px="20.5px"
                  py="10px"
                  backgroundColor="golden"
                  title="View All Product Blogs"
                  handleClick={() => router.push("/blogs/category/product-information")}
                />
              </Box>
            </Flex>
            {<BlogList blogs={productBlogs} />}
          </Box>
        )}
        {ayurvedaBlogs && ayurvedaBlogs.length > 0 && (
          <Box mt="10" mb="5" width={{ base: "90%", "2xl": "1350px" }}>
            <Flex
              flexDirection={{ base: "column", lg: "row" }}
              justifyContent={{ base: "flex-start", lg: "space-between" }}
            >
              <Box>
                <Text
                  lineHeight="1"
                  color="titleColor"
                  variant="headingHomePage"
                >
                  Ayurveda & Wellness
                </Text>
              </Box>
              <Box>
                <Button
                  mt={{ base: "20px", lg: "0px" }}
                  px="20.5px"
                  py="10px"
                  backgroundColor="golden"
                  title="View All Ayurveda & Wellness Blogs"
                  handleClick={() => router.push("/blogs/category/ayurveda-wellness")}
                />
              </Box>
            </Flex>
            {<BlogList blogs={ayurvedaBlogs} />}
          </Box>
        )}
      </Center>
    </>
  );
}

export const getStaticProps = wrapper.getStaticProps((store) => async () => {
  try {
    await store.dispatch(fetchProductCategories());

    const productBlogs = await fetchBlogsForCategory(
      BLOG_CATEGORY_DETAILS.PRODUCT_INFORMATION.id
    );

    const ayurvedaBlogs = await fetchBlogsForCategory(
      BLOG_CATEGORY_DETAILS.AYURVEDA_WELLNESS.id
    );

    return {
      props: {
        productBlogs: JSON.stringify(productBlogs),
        ayurvedaBlogs: JSON.stringify(ayurvedaBlogs),
      },
    };
  } catch (err) {
    return {
      props: {
        errorMessage: err.message,
      },
    };
  }
});
